// extracted by mini-css-extract-plugin
export default {"badges":"Badges_badges__qXZAE","badge":"Badges_badge__5Ou9X"};